import React from 'react';
import { Button, CircularProgress } from '@mui/material';
import { styled } from '@mui/system';

const StyledButton = styled(Button)(({ theme }) => ({
  marginTop: theme.spacing(2),
  padding: theme.spacing(1.5),
  fontSize: '1rem',
  textTransform: 'none',
}));

const PrimaryButton = ({ isLoading, disabled, children, ...props }) => {
  return (
    <StyledButton
      variant="contained"
      color="primary"
      disabled={isLoading || disabled}
      {...props}
    >
      {isLoading ? <CircularProgress size={24} color="inherit" /> : children}
    </StyledButton>
  );
};

export default PrimaryButton;